@if (items$ | withLoading | async; as result) {
  @if (result.loading) {
    <app-spinner-filled />
  } @else {
    @if (isNotEmpty(result.value)) {
      <div class="grid-cols-9 gap-8 lg:grid">
        <div class="col-span-5">
          <div>
            @for (item of result.value; track item.id) {
              <app-public-cart-item [item]="item" />

              <p-divider appPrimengDivider />
            }
          </div>

          <div>
            <ng-content />
          </div>
        </div>

        <div class="col-span-4">
          @if (details$ | withLoading | async; as result) {
            @if (result.loading) {
              <app-spinner-filled />
            } @else {
              @if (!isNil(result.value)) {
                <app-public-cart-summary
                  (checkoutClickEvent)="handleCheckoutClickEvent()"
                  [details]="result.value" />
              }
            }
          }
        </div>
      </div>
    } @else {
      <app-public-cart-empty />
    }
  }
}
